import {FormattedMessage} from "react-intl";
import IconClose from "@/assets/icons/icon-close.svg?react";
import {Button} from "@/components/Button";
import type {ModalProps} from "@/components/Modal";
import {Modal} from "@/components/Modal";

type GeolocationPermissionDeniedModalProps = Omit<ModalProps, "children">;

export function GeolocationPermissionDeniedModal(props: GeolocationPermissionDeniedModalProps) {
    return (
        <Modal {...props}>
            <Modal.Header>
                <Modal.Title>
                    <FormattedMessage id="geolocation_permission_denied_title" />
                </Modal.Title>
                <Button variant="plain" onClick={props.onHide}>
                    <IconClose />
                </Button>
            </Modal.Header>
            <Modal.Body>
                <FormattedMessage id="geolocation_permission_denied_message" />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide} variant="primary" fullWidth>
                    <FormattedMessage id="geolocation_permission_denied_button" />
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
